import React, { createContext, useContext, useState, ReactNode, useMemo, useCallback } from 'react';

interface DialogContextType {
  openDialog: (dialogType: string, dialogProps?: any) => void;
  closeDialog: () => void;
  activeDialog: string | null;
  dialogProps: any;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeDialog, setActiveDialog] = useState<string | null>(null);
  const [dialogData, setDialogData] = useState<any>({});

  const openDialog = useCallback((dialogType: string, props: any = {}) => {
    setActiveDialog(dialogType);
    setDialogData(props);
  }, []);

  const closeDialog = useCallback(() => {
    setActiveDialog(null);
    setDialogData({});
  }, []);

  const contextValue = useMemo(() => ({
    openDialog,
    closeDialog,
    activeDialog,
    dialogProps: dialogData,
  }), [openDialog, closeDialog, activeDialog, dialogData]);

  return (
    <DialogContext.Provider value={contextValue}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider');
  }
  return context;
};
